import { render, staticRenderFns } from "./AdminLicensesList.vue?vue&type=template&id=622e7008&scoped=true"
import script from "./AdminLicensesList.vue?vue&type=script&lang=ts"
export * from "./AdminLicensesList.vue?vue&type=script&lang=ts"
import style0 from "./AdminLicensesList.vue?vue&type=style&index=0&id=622e7008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622e7008",
  null
  
)

export default component.exports